import { slideUp, slideDown } from './animations.js'; // Import slide functions

export const menuInit = () => {
    // Hamburger menu click
    const hamburger = document.querySelector('.js-hamburger');
    if (hamburger) {
        hamburger.addEventListener('click', mobileMenuOpen);
    }

    // Navigation submenu - update to handle all submenus
    const navSubmenus = document.querySelectorAll('.js-nav-has-sub-menu');
    if (navSubmenus.length) {
        navSubmenus.forEach(submenu => {
            submenu.addEventListener('click', menuOpen);
        });
    }

    // Close menu when clicking outside
    document.addEventListener('mouseup', menuClose);
};

export const menuOpen = (e) => {
    let clickedMenu = e.currentTarget;
    const subMenu = clickedMenu.querySelector('.c-nav-primary-sub-menu');
    
    if (!subMenu) return;

    // Check if click is occurring on the mobile menu
    const mobileActive = document.querySelector('.js-mobile-active');
    const isMobileActive = mobileActive && mobileActive.classList.contains('mobile-active');
    
    if (isMobileActive) {
        // Check if mobile menu already has an expanded sub-menu
        const activeMenus = document.querySelectorAll('.menu-active');
        if (activeMenus.length && !clickedMenu.classList.contains('menu-active')) {
            // Close other menus first
            activeMenus.forEach(menu => {
                const activeSubMenu = menu.querySelector('.c-nav-primary-sub-menu');
                if (activeSubMenu) {
                    slideUp(activeSubMenu, 300);
                }
                menu.classList.remove('menu-active');
            });
            // Then open the clicked menu
            slideDown(subMenu, 300);
            clickedMenu.classList.add('menu-active');
        } else if (clickedMenu.classList.contains('menu-active')) {
            slideUp(subMenu, 300);
            clickedMenu.classList.remove('menu-active');
        } else {
            slideDown(subMenu, 300);
            clickedMenu.classList.add('menu-active');
        }
        return;
    }
    
    // Desktop Menu
    if (clickedMenu.classList.contains('menu-active')) {
        document.querySelectorAll('.menu-active .c-nav-primary-sub-menu__link')
            .forEach(link => link.setAttribute('tabindex', '-1'));
        clickedMenu.classList.remove('menu-active');
        document.querySelector('.c-site-header__nav-wrapper').style.overflow = 'visible';
    } else {
        // Close other open menus first
        document.querySelectorAll('.js-nav-has-sub-menu')
            .forEach(menu => menu.classList.remove('menu-active'));
        document.querySelector('.c-site-header__nav-wrapper').style.overflow = 'visible';
        clickedMenu.classList.add('menu-active');
    }

    // Update tab indexes
    const activeLinks = document.querySelectorAll('.menu-active .c-nav-primary-sub-menu__link');
    if (clickedMenu.classList.contains('menu-active')) {
        activeLinks.forEach(link => link.removeAttribute('tabindex'));
    } else {
        activeLinks.forEach(link => link.setAttribute('tabindex', '-1'));
    }
};

export const mobileMenuOpen = (e) => {
    const hamburger = e.currentTarget;
    hamburger.classList.toggle('open');
    document.querySelector('.js-mobile-active').classList.toggle('mobile-active');
    document.body.classList.toggle('no-scroll');
    if (typeof closeSearch === 'function') {
        closeSearch();
    }
};

export const menuClose = (e) => {
    const menus = document.querySelectorAll('.js-nav-has-sub-menu');
    const clickedElement = e.target;

    // Remove ability to tab to hidden items
    document.querySelectorAll('.menu-active .c-nav-primary-sub-menu__link')
        .forEach(link => link.setAttribute('tabindex', '-1'));

    // Check if click was outside menu
    const clickedInsideMenu = Array.from(menus).some(menu => 
        menu === clickedElement || menu.contains(clickedElement)
    );

    if (!clickedInsideMenu) {
        menus.forEach(menu => menu.classList.remove('menu-active'));
        const navWrapper = document.querySelector('.c-site-header__nav-wrapper');
        if (navWrapper) {
            navWrapper.style.overflow = 'hidden';
        }
    }
};